import { render, staticRenderFns } from "./ClientDashboardListModal.vue?vue&type=template&id=08fd235d&"
import script from "./ClientDashboardListModal.vue?vue&type=script&lang=js&"
export * from "./ClientDashboardListModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientDashboardListModal.vue?vue&type=style&index=0&id=08fd235d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports